import type {ReactElement, ReactNode} from 'react';
import {ClickableDiv} from '@Components/clickable-div';
import {Text, TextSize} from '@Components/text';
import {SharedInTeamIndicator} from '@Components/shared-in-team-indicator/shared-in-team-indicator';
import {SurveyOptionImage} from '@Components/ai-chat-window/components/survey-option-image/survey-option-image';
import styles from './fields.module.scss';

export interface OptionCardProps {
  label: string;
  isSelected: boolean;
  onClick: () => void;
  leadingSlot?: ReactNode;
  imageUrl?: string;
  isSharedInTeam?: boolean;
}

export function OptionCard({label, isSelected, onClick, leadingSlot, imageUrl, isSharedInTeam = false}: OptionCardProps): ReactElement {
  const cardClass = isSelected ? `${styles.optionCard} ${styles.optionCardSelected}` : styles.optionCard;

  const renderThumb = (): ReactElement | null => {
    if (imageUrl === undefined || imageUrl === '') {
      return null;
    }
    return <SurveyOptionImage imageUrl={imageUrl} className={styles.optionThumb} alt={label} />;
  };

  return (
    <ClickableDiv className={cardClass} onClick={onClick}>
      {leadingSlot}
      {renderThumb()}
      <Text size={TextSize.XSMALL} val={label} bold={isSelected} />
      {isSharedInTeam ? <SharedInTeamIndicator tooltipId={`survey-option-shared-in-team-${label}`} /> : null}
    </ClickableDiv>
  );
}
